module.exports = __webpack_public_path__ + "media/tycho2t3_80_grey_mx.3cbc2f31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_grey_mx.jpg
// module id = 1096
// module chunks = 0